export default {
  // 圖例標籤
  basic: "基礎",
  behavior: "行為",
  entity: "實體",
  clue: "線索",
  maliciousBlack: "惡意黑",
  maliciousGray: "惡意灰",
  transaction: "交易",
};
